/* Harmony Elements — cart behaviour.
   1. Quantity control for cart rows that were MERGED for display (see cart-products.liquid).
      A BXGY discount applies to one unit, so Shopify splits a variant across two lines. The
      template renders the group once; the control has to act on the whole group, which means
      /cart/update.js keyed by variant id, not /cart/change.js keyed by line.
   2. Add-to-cart confirmation on the product page — the button itself becomes the receipt. */
(function () {
  var CSS =
    '.dn-qty{display:inline-flex;align-items:center;gap:2px;border:1px solid rgba(43,38,34,.18);' +
    'border-radius:100px;padding:2px;background:#FBF8F1}' +
    '.dn-qty__b{width:32px;height:32px;border:0;border-radius:100px;background:transparent;' +
    'font-size:1.05rem;line-height:1;color:#2B2622;cursor:pointer}' +
    '.dn-qty__b:hover{background:rgba(43,38,34,.07)}' +
    '.dn-qty__b[disabled]{opacity:.4;cursor:default}' +
    '.dn-qty__n{min-width:26px;text-align:center;font-weight:600}' +
    '.dn-qty.busy{opacity:.5;pointer-events:none}' +
    /* product-page confirmation: restrained, brand green, and it says what happened */
    '.dn-added{background:#E6EFE4 !important;color:#3F6B4A !important;border-color:#3F6B4A !important}' +
    '.dn-added .dn-tick{display:inline-block;margin-right:8px;transform:scale(0);' +
    'animation:dnPop .32s cubic-bezier(.2,1.4,.4,1) forwards}' +
    '@keyframes dnPop{to{transform:scale(1)}}' +
    '@keyframes dnNudge{0%,100%{transform:scale(1)}35%{transform:scale(1.14)}}' +
    '.dn-nudge{animation:dnNudge .45s ease}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(body) });
  }

  // ---- 1. merged-row quantity + remove -----------------------------------------------------
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dn-qty__b, .dn-cart-remove');
    if (!b) return;
    e.preventDefault();
    var host = b.closest('[data-keys]');
    if (!host) return;
    var keys = host.getAttribute('data-keys').split(',').filter(Boolean);
    if (!keys.length) return;
    var qty;
    if (b.classList.contains('dn-cart-remove')) {
      qty = 0;
    } else {
      qty = parseInt(host.getAttribute('data-qty'), 10) + parseInt(b.getAttribute('data-d'), 10);
      if (qty < 0) return;
    }
    var box = host.querySelector('.dn-qty') || host;
    box.classList.add('busy');
    // Keying updates by VARIANT only moves the first line of a split group — verified: the
    // call returns 200 and the second line is left untouched. Collapse the group onto its
    // first line instead and zero the rest; Shopify re-splits if the discount still needs it.
    var u = {};
    keys.forEach(function (k, i) { u[k] = i === 0 ? qty : 0; });
    post('/cart/update.js', { updates: u })
      .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
      .catch(function () { box.classList.remove('busy'); });
  });

  // ---- 2. product-page add-to-cart confirmation --------------------------------------------
  // Comparing the cart count before and after a click races with the add itself: the "before"
  // fetch can resolve after the item has already landed, and then the count never appears to
  // grow. Watch the /cart/add request instead — that is unambiguous.
  var lastBtn = null;
  var ADD_SEL = '.product-form-buttons button[name="add"], #dnQt .dn-qt__cta, ' +
                'add-to-cart-component button, .add-to-cart-button';

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(ADD_SEL);
    if (!b) return;
    // A CARD's quick-add is a fixed-width pill. Morphing its label there rewrote the text
    // over the pseudo-element label and stretched it 134px -> 229px mid-click, which is
    // exactly the jarring half-shown message. Cards get the tint + cart nudge only; the
    // full "Added to your basket" morph belongs to the product page's buy button.
    // A CARD's pill stays exactly as it is — the reference store gives no per-button
    // confirmation, and every attempt at one here either stretched the pill or fought the
    // theme's own label rig. The cart badge is the feedback.
    if (b.closest('.product-card')) {
      if (window.DNCart) window.DNCart.celebrate();
      return;
    }
    // the tier widget proxies its CTA into the theme's hidden button, so keep the FIRST
    // button of a burst — that is the one the shopper actually sees
    if (!lastBtn) { lastBtn = b; setTimeout(function () { lastBtn = null; }, 4000); }
  }, true);

  function celebrate(btn) {
    var badge = document.querySelector('#dnFloatCart, .dn-floating-cart, cart-icon, .header__cart');
    if (badge) { badge.classList.remove('dn-nudge'); void badge.offsetWidth; badge.classList.add('dn-nudge'); }
    if (!btn || btn.dataset.dnBusy) return;
    btn.dataset.dnBusy = '1';
    var label = btn.innerHTML;
    btn.innerHTML = '<span class="dn-tick">&#10003;</span>Added to your basket';
    btn.classList.add('dn-added');
    setTimeout(function () {
      btn.innerHTML = label; btn.classList.remove('dn-added'); delete btn.dataset.dnBusy;
    }, 2200);
  }
  window.DNCart = { celebrate: function () { celebrate(null); } };

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      p.then(function (r) {
        if (r && r.ok && lastBtn) { var b = lastBtn; lastBtn = null; celebrate(b); }
      }).catch(function () {});
    }
    return p;
  };
})();


/* dnHeaderOffset — the logo row scrolls away naturally, the nav row stays stuck.
   The whole header group is position:sticky; giving it a negative top equal to the logo
   row's height means the browser handles the hand-off — no class toggling at a scroll
   threshold, which is what made the old version jump mid-scroll. */
(function () {
  function apply() {
    var sec = document.querySelector('header.shopify-section-group-header-group');
    var row = document.querySelector('.header__row--top');
    if (!sec || !row) return;
    sec.style.top = -(row.offsetHeight) + 'px';
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();


/* dnQuickAddFlow — Horizon renders quick-add as an overlay on the card image; the design
   wants it as the card's last row, always visible. Move the component, don't fight the CSS. */
(function () {
  function place(card) {
    var qa = card.querySelector('.quick-add');
    var content = card.querySelector('.product-card__content');
    if (qa && content && qa.parentElement !== content) content.appendChild(qa);
  }
  function all() { document.querySelectorAll('.product-card').forEach(place); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.product-card')) place(n);
        if (n.querySelectorAll) n.querySelectorAll('.product-card').forEach(place);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/* DNEMPTYCLOSE — "Continue shopping" in the EMPTY cart drawer linked to /collections/all, which
   dumped the shopper into the 4,700-product A-Z index. Inside the drawer it should do what the X
   does: dismiss the sheet and leave them where they were. Scoped to #cart-drawer, so the same
   button on the standalone /cart page still navigates as normal.

   ⚠ Do NOT do this by clicking the X. That button is bound declaratively —
   on:click="#cart-drawer/close" — and Horizon's binding ignores a synthetic .click(); the first
   attempt preventDefault'd the link but left the drawer open. Call the element's own close().

   ⚠ close() is ASYNC and does not look like it worked. ThemeDrawer#closeDialog drops the [open]
   attribute, unlocks scroll, then AWAITS the slide-out before calling panel.close() — so a
   dialog.open read in the same tick still says true. That reading is what made two earlier
   attempts look broken; it was measuring mid-animation, not a failure. Give it ~1s before you
   judge it. The timeout below is only a belt-and-braces finisher for the case where the
   animation never resolves; when the theme behaves, it finds the dialog already shut and
   does nothing. */
(function () {
  var ANIM_GRACE = 700;  // comfortably longer than --animation-speed

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.cart-items__empty-button');
    if (!link) return;
    var drawer = link.closest('#cart-drawer');
    if (!drawer) return;
    e.preventDefault();

    if (typeof drawer.close === 'function') drawer.close();

    setTimeout(function () {
      var dlg = drawer.querySelector('dialog');
      if (dlg && dlg.open) dlg.close();
    }, ANIM_GRACE);
  });
})();
